import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../../views/Invoices/Components/InvoiceDetails/style";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
// import Modal from "@mui/material/Modal";
import {
  GridList,
  GridListTile,
  Modal,
  Backdrop,
  Fade,
} from "@material-ui/core";

// const useStyles = makeStyles(dashboardStyle);
const useStyles = makeStyles((theme) => ({
  gridList: {
    flexWrap: "nowrap",
    transform: "translateZ(0)",
  },
  modal: {
    display: "flex",
    justifyContent: "end",
    overflow: "scroll",
    height: "100%",
  },
  img: {
    outline: "none",
    marginTop: "70px",
    width: "50%",
    height: "100%",
  },
}));

const FileAttachments = ({
  rotate,
  pdfHeight,
  docsrc,
  attachmentURLList,
  formState,
  imgRef,
  imgsrc,
  dimensions,
  scale,
}) => {
  let source = docsrc;

  const classes = useStyles();
  // const extension = source?.match(/\.[^.]+$/)[0]?.substring(1);
  const extension = (source?.match(/\.[^.]+$/) || [])[0]?.substring(1);

  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions?.includes(fileExtension?.toLowerCase());
  };
  const [image, setImage] = React.useState("false");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
 
  const handleImage = (value) => {
    setImage(value);
    setOpen(true);

  };

  return (
    <div
      style={{
        marginLeft: "10px",
        overflow: "hidden",
        overflowX: "auto",
      }}
      className="scrollable"
    >
      {imgsrc && (
        <img
          className="mx-1"
          style={{
            height: dimensions.height,
            width: dimensions.width,
          }}
          width="auto"
          height="auto"
          src={`${process.env.REACT_APP_API_URL}/${imgsrc}`}
          ref={imgRef}
        />
      )}
      {/* style="width: 600px;height: 701px;min-height: 38%;" */}
      {source && (
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Typography style={{ marginTop: "2px" }}>
            {/* {docsrc?.slice(8)} */}
            {docsrc?.split("\\")?.pop()}
          </Typography>

          {source.substr(source.length - 3) === "pdf" ||
          source.substr(source.length - 3) === "PDF" ? (
            <iframe
              // width="48%"

              style={{
                // position: "absolute",
                minHeight: `${pdfHeight}`,
                //: "auto",
                // height : dimensions.height,
                // width: dimensions.width
                width: "200%",
                height: "601px",
              }}
              src={`${process.env.REACT_APP_API_URL}/${source}`}
            />
          ) : isContainEmailFormate(extension) ? (
            // <Grid container justifyContent="center" textAlign="center" bgcolor="red" >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              justifyContent="center"
              textAlign="center"
            >
              <div
                style={{
                  width: "200%",
                  height: "100%",
                }}
              >
                <Typography component="h1" variant="h2" mt={10}>
                  {" "}
                  No Preview Available{" "}
                </Typography>
                <Typography component="h5" variant="h6" mt={1}>
                  {" "}
                  Can Be Download Only{" "}
                </Typography>
              </div>
            </Grid>
          ) : (
            // </Grid>
            <div
            //  style={{
            //   overflowX: "scroll",
            //   width:"100%",
            //   height:"100%"
            // }}
            >
              {/* <a
                href={`${process.env.REACT_APP_API_URL}/${source}`}
                target="_blank" // This will open the link in a new tab
                rel="noopener noreferrer" // Recommended for security reasons when using target="_blank"
                onClick={()=>handleOpen()}

              >
                <img
                  // className={classes.AltImage}
                  id="slider"
                  style={{
                    overflow: "hidden",
                    overflowX: "auto",
                    transform: `rotate(${rotate}deg)`,
                    transition: "all 0.2s ease",
                    minWidth: `${pdfHeight}`,
                    paddingTop: ` ${rotate / 2 !== 0 ? 140 : 0}px`,
                    paddingBottom: ` ${rotate / 2 !== 90 ? 0 : 0}px`,
                    height: dimensions.height,
                    width: dimensions.width,
                    //apply padding top for css enabled
                  }}
                  // width="80%"
                  width="200%"
                  height="100%"
                  ref={imgRef}
                  src={`${process.env.REACT_APP_API_URL}/${source}`}
                  alt="file can't preview"

                />
              </a> */}

              <img
                // className={classes.AltImage}
                id="slider"
                style={{
                  overflow: "hidden",
                  overflowX: "auto",
                  transform: `rotate(${rotate}deg)`,
                  transition: "all 0.2s ease",
                  minWidth: `${pdfHeight}`,
                  paddingTop: ` ${rotate / 2 !== 0 ? 140 : 0}px`,
                  paddingBottom: ` ${rotate / 2 !== 90 ? 0 : 0}px`,
                  height: dimensions.height,
                  width: dimensions.width,
                  //apply padding top for css enabled
                }}
                // width="80%"
                width="200%"
                height="100%"
                ref={imgRef}
                src={`${process.env.REACT_APP_API_URL}/${source}`}
                alt="file can't preview"
                // onClick={() => handleOpen()}
                onClick={(e) =>
                  handleImage(`${process.env.REACT_APP_API_URL}/${source}`)
                }
              />
            </div>
          )}
        </Grid>
      )}

      <div
        style={
          {
            // overflow:'scroll',
          }
        }
      >
        <Modal
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
        >
          <Fade in={open} timeout={500} className={classes.img}>
            <img
              src={image}
              alt="asd"
              // style={{ maxHeight: "90%", maxWidth: "90%" }}
            />
          </Fade>
        </Modal>
      </div>
    </div>
  );
};

export default FileAttachments;
